<div class="is-relative is-flex is-justify-center">
  <app-icon
      class="is-overlay is-flex is-justify-center is-size-3 is-family-semiBold has-text-centered"
      [name]="'warning-circle-composition-overlay'">
  </app-icon>
  <app-icon name="warning-circle-composition-background" class="has-text-danger has-margin-centered is-size-3"></app-icon>
</div>
